/*
 Created by CHT 2019/9/17 15:34
 容器组件
 */
import {uuid, getId} from "../utils"
import RyFormItem from "../RyFormItem"
import {
  PERMISSION__EDITOR,
  FORM_ITEM__SECTION,
  PERMISSION__READ,
  PERMISSION__HIDDEN
} from "../types"

class Sectional extends RyFormItem {

  constructor(dataId) {
    super()
    this.dataId = dataId || uuid()
    this.sectionName = Sectional._title
    this.remark = ''
    this.$permission = this.permissionOptional[0].value
  }

  get permission() {
    if(this.children.length === 0) {
      this.$permission = PERMISSION__HIDDEN
    }
    return this.$permission
  }

  set permission(permission) {
    const hasPermission = this.permissionOptional
      .map(permission => permission.value)
      .includes(permission)
    if (hasPermission) {
      this.$permission = permission

      if (this.children && this.children.length) {
        this.children.forEach(field => {
          field.setPermission(permission)
        })
      }
    }
  }

  get hiddenStatus () {
    let hidden = true
    this.children.forEach(item => {
      if (item.permission !== PERMISSION__HIDDEN && !item.hidden && !item.followHidden && item.displayInfo.show) {
        hidden = false
      }
    })
    return hidden
  }
}

Sectional._title = ''
Sectional.type = FORM_ITEM__SECTION
Sectional.icon = ''
Sectional.use = true

Sectional.prototype.type = Sectional.type
Sectional.prototype.permissionOptional = [
  {
    value: PERMISSION__EDITOR,
    label: '编辑'
  },
  {
    value: PERMISSION__READ,
    label: '只读'
  },
  {
    value: PERMISSION__HIDDEN,
    label: '隐藏'
  }
]
Sectional.prototype.setConf = function (opts) {
  const {
    dataId,
    sectionName,
    remark
  } = opts

  this.dataId = dataId || uuid('SEC')
  this.sectionName = sectionName || ''
  this.remark = remark
}
Sectional.prototype.getConf = function () {
  return {
    type: this.type,
    dataId: this.dataId,
    sectionName: this.sectionName,
    remark: this.remark,
    permission: this.$permission
  }
}
Sectional.prototype.setStructure = function ({next, prev, parent, firstChild}) {
  this.next = next
  this.prev = prev
  this.parent = parent || this.root
  this.firstChild = firstChild
}
Sectional.prototype.getStructure = function () {
  return {
    next: getId(this.next),
    prev: getId(this.prev),
    parent: null,
    firstChild: getId(this.firstChild)
  }
}
Sectional.prototype.setPermission = function (permission) {
  const hasPermission = this.permissionOptional
    .map(permission => permission.value)
    .includes(permission)
  if (hasPermission) {
    this.$permission = permission
  } else {
    this.$permission = item.permissionOptional[0].value
  }
}

export default Sectional

